import { useMutation } from '@apollo/client';

import { FooterNavigator } from '../../Footer/FooterNavigator';
import { Icon } from '../../UI';

import { useModalContext } from '../../../context/Modal';
import { useUserStrategies } from '../../../context/UserStrategies';

import { UPDATE_ASSET_ADV_SETT } from '../../../http/apollo-queries';

import { getStrategyAssetTargets } from '../../../helpers/functions';

import { useTargets } from '../../../hooks/useTargets';

import { Currency } from '../../../types/common';
import { IStrategyAsset } from '../../../types/model';
import { useState } from 'react';

export const AdvancedSettings = ({
  asset: {
    alert,
    entryPrice,
    purchasedAt,
    inspirationSource,
    id,
    bank,
    entryExchangePrice,
    strategyAssetTargets: { items },
  },
  currency,
  onlyTargets = false,
}: {
  asset: IStrategyAsset;
  currency: Currency['code'];
  onlyTargets?: boolean;
}) => {
  const { closeModal } = useModalContext();
  const { refetch: refetchStrategies, loading: loadingStrategies } =
    useUserStrategies();
  const [custodian, setCustodian] = useState(bank);

  const { isAlertTargetActive, isDisabledSaveAction, inspiration, targets } =
    useTargets({
      alert,
      entryPrice,
      inspirationSource,
      items,
      entryExchangePrice: entryExchangePrice ?? 1,
    });

  const [updateStrategyAssetAdvancedSettings, { loading }] = useMutation(
    UPDATE_ASSET_ADV_SETT,
    {
      onCompleted: () => refetchStrategies().then(() => closeModal()),
      variables: {
        input: {
          alert: isAlertTargetActive,
          id,
          bank: custodian,
          inspirationSource: inspiration,
          strategyAssetTargets: getStrategyAssetTargets(
            targets,
            isAlertTargetActive
          ),
        },
      },
    }
  );

  return (
    <>
      <div
        className={
          'flex flex-col h-full w-full justify-between overflow-y-auto pb-4'
        }
      >
        <div className={'px-20'}></div>
        {/* footer */}
      </div>
      <FooterNavigator
        buttonsPosition="between"
        className={`
          border-t
          left-0
          right-0
          bottom-0
          rounded-b-xl
          border-grey-10
          bg-white
          flex-grow-0
          flex-shrink-0
        `}
        cancelButtonName="Back"
        cancelButtonSVG={
          <Icon svgName="arrowBack" className="mr-2" canUseDarkMode={false} />
        }
        cancelButtonClassName="border-none hover:bg-white"
        loading={loading || loadingStrategies}
        saveButtonName="Save"
        onCancel={closeModal}
        onSave={updateStrategyAssetAdvancedSettings}
        isDisabledSaveButton={bank === custodian && isDisabledSaveAction}
      />
    </>
  );
};
